module.exports = __webpack_public_path__ + "static/og-logo-12a5887d95fe537f281ca4cdf3b74380.jpg";